{
  "messages": {
    "loading": "Loading messages...",
    "empty": "No messages yet. Start the conversation!",
    "noEntitiesSelected": "Please select entities from the dropdown above to view messages.",
    "counter": "Messages / {{count}}",
    "reply": "Reply",
    "replyPlaceholder": "Write a reply...",
    "replyPlaceholderInternal": "Write an internal reply...",
    "replyPlaceholderClient": "Write a reply visible to clients...",
    "cancel": "Cancel",
    "send": "Send",
    "important": "Important",
    "scrollToBottom": "Scroll to bottom",
    "refresh": "Refresh messages"
  },
  "tabs": {
    "internal": "Internal", 
    "client": "Client",
    "all": "All"
  },
  "visibility": {
    "client": "Client"
  },
  "thread": {
    "reply": "reply",
    "replies": "replies"
  },
  "filters": {
    "relatedEntities": "Related Entities",
    "selectEntities": "Select Entities",
    "selectEntitiesDescription": "View messages from multiple entities",
    "selectEntitiesPlaceholder": "Select entities...",
    "all": "All",
    "current": "Current",
    "typesSelected": "{{count}} types selected",
    "important": "Important",
    "showImportant": "Show Important",
    "showImportantOnly": "Show important messages only",
    "showAllMessages": "Show all messages"
  },
  "input": {
    "placeholder": "Write a message...",
    "placeholderAllTab": "Switch to Internal or Client tab to send messages",
    "placeholderInternal": "Write an internal update...",
    "placeholderClient": "Write a message visible to clients...",
    "warningNote": "Note:",
    "warningMessage": "Select the current entity ({{entityKey}}) to send messages."
  },
  "emoji": {
    "title": "Add Emoji",
    "popoverTitle": "Insert Emoji",
    "categories": {
      "Smileys": "Smileys",
      "Gestures": "Gestures", 
      "Objects": "Objects",
      "Symbols": "Symbols"
    }
  },
  "tooltips": {
    "mentions": "@Mentions coming soon!",
    "attachments": "Attachments coming soon!",
    "bold": "Bold",
    "italic": "Italic", 
    "underline": "Underline",
    "numberedList": "Numbered list",
    "bulletList": "Bullet list",
    "link": "Link",
    "showFormatting": "Show formatting",
    "hideFormatting": "Hide formatting",
    "insertEmoji": "Insert emoji",
    "sendMessage": "Send message (Ctrl+Enter)",
    "enterUrl": "Enter URL:",
    "addLink": "Add Link",
    "linkText": "Link text",
    "markAsImportant": "Mark as important",
    "markAsNormal": "Remove importance",
    "migrated": "Migrated",
    "important": "Important"
  },
  "time": {
    "justNow": "just now",
    "minuteAgo": "{{count}} minute ago",
    "minutesAgo": "{{count}} minutes ago",
    "hourAgo": "{{count}} hour ago", 
    "hoursAgo": "{{count}} hours ago",
    "dayAgo": "{{count}} day ago",
    "daysAgo": "{{count}} days ago",
    "monthAgo": "{{count}} month ago",
    "monthsAgo": "{{count}} months ago",
    "yearAgo": "{{count}} year ago",
    "yearsAgo": "{{count}} years ago"
  },
  "accessibility": {
    "closeChatPanel": "Close chat panel",
    "openChat": "Open chat"
  }
}
